<div class="col-sm-12">
  <label class="control-label">{{ 'forms.form-builder.affiliation-code.affiliation-code-type' | translate | titlecase }}</label>
  <select class="form-control" [(ngModel)]="affCodeSettings.AffCodeTypeId" (change)="onAffCodeTypeChange($event.target.value)">
    <option value="">{{ 'common.select-one' | translate | titlecase }}</option>
    <option *ngFor="let item of affCodeTypes" [value]="item.AffCodeTypeID">{{ item.AffCodeType }}</option>
  </select>
</div>
<div class="col-sm-12">
  <label class="control-label">{{ 'forms.form-builder.affiliation-code.affiliation-codes' | translate | titlecase }}</label>
  <div class="clear"></div>
  <div class="col-sm-6" *ngFor="let option of affCodeSettings.AffCodeOptions">
    <label class="control-label"> <input type="checkbox" [(ngModel)]="option.Visible" /> {{ option.Name }} </label>
    <input class="pull-right" type="text" [(ngModel)]="option.LabelText" placeholder="{{ option.Name }}" />
  </div>
</div>
